import React, { Component } from 'react';

import { CtAdminTargetAdd } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminTargetMenu.css';
const cx = classNames.bind(styles);

class AdminTargetMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={cx('func-list')}>
        <CtAdminTargetAdd />
      </div>
    );
  }
}

AdminTargetMenu.propTypes = {
  //
};
AdminTargetMenu.defaultProps = {
  //
};

export default AdminTargetMenu;



// WEBPACK FOOTER //
// ./src/script/components/admin/target/AdminTargetMenu.js